import { Link } from "react-router-dom";
import slugify from "../../../utils/slugify";

const GroupPerformersByRole = ({ performers }) => {
  const grouped = performers.reduce((acc, p) => {
    if (!acc[p.role]) acc[p.role] = [];
    acc[p.role].push(p);
    return acc;
  }, {});

  return (
    <div>
      {Object.entries(grouped).map(([role, group], i) => (
        <p key={i} className="text-black">
          <span className="font-lato-light-important text-base">
            {role.trim()}:
          </span>
          <span className="inline-block w-2"></span>
          <span className="font-lato-light-important text-base">
            {group
              .map((p, idx) => {
                const nameWithDate = `${p.name}${p.date ? ` (${p.date})` : ""}`;
                return p.famousPerformer ? (
                  <Link
                    key={p._id || idx}
                    to={`/performers/${slugify(p.name)}`}
                    className="text-black hover:text-opera-hover no-underline"
                  >
                    {nameWithDate}
                  </Link>
                ) : (
                  <span key={p._id || idx}>{nameWithDate}</span>
                );
              })
              .reduce((prev, curr) => [prev, " / ", curr])}
          </span>
        </p>
      ))}
    </div>
  );
};

export default GroupPerformersByRole;
